import gql from 'graphql-tag';

export const GET_USER_PROFILE = `
  query {
    getUserProfile {
      primeUser
      firstName
      lastName
      middleName
      suffix
      primaryEmail
      secondaryEmail
      phoneNumber
      associations {
        entityId
        entityName
        credentialId
        mfaExpirationDate
        restrictNameForIndividual
        firstName
        lastName
        middleName
        suffix
        username
        title
        email
        phoneNumber
        userType
        regulatorCode
      }
    }
  }
`;

export const GET_INDIVIDUAL_SUMMARY = `
query getIndividualSummary($individualId: Float!) {
  getIndividualSummary(individualId: $individualId) {
        birthCountryCode
        birthStateCode
        dateOfBirth
        eyeColorCode
        firstName
        genderCode
        hairColorCode
        height
        heightFeet
        individualId
        individualName
        lastName
        middleName
        raceCode
        ssn
        suffix
        weight
        activeLicenses {
            licenseId
            licenseTypeCode
            licenseTypeDescription
            regulatorCode
            regulatorDescription
            stateCode
            stateDescription
        }
        contactDetails {
            address {
                city
                country
                postalCode
                state
                street1
                street2
            }
            email {
                notificationEmail
                workEmail
            }
            phone {
                businessPhoneExtension
                businessPhoneNumber
            }
        }
        relationships {
            companyId
            companyName
            establishedBy
            finalTerminationDate
            initialTerminationDate
            lastUpdatedBy
            lastUpdatedDate
            relationshipBeginDate
            relationshipId
            remoteWorkType
            remoteWorkTypeDescription
            terminatedBy
            terminationDeceasedDate
            terminationEditReason
            terminationExplanation
            terminationReason
            workerClassification
            workerClassificationBeginDate
            businessPhone
            businessPhoneExtension
            businessEmail
            position
            locations {
                locationBeginDate
                locationEndDate
                locationId
                locationType
                address {
                    city
                    country
                    postalCode
                    state
                    street1
                    street2
                }
            }
            sponsorships {
                companyRelationshipId
                initialAcceptanceDate
                isActive
                lastUpdatedBy
                lastUpdatedDate
                licenseName
                licenseStatus
                regulatorName
                rejectionReason
                sponsorshipId
                sponsorshipStatus
                sponsorshipStatusDate
            }
            remoteLocation {
                isResidential
                address {
                    city
                    country
                    postalCode
                    state
                    street1
                    street2
                }
                licenseAssociations {
                    licenseId
                    licenseTypeCode
                    licenseTypeDescription
                    regulatorCode
                    regulatorDescription
                    stateCode
                    stateDescription
                }
            }
        }
    }
}
`;

export const GET_INDIVIDUAL_SUMMARY_FOR_PRIOR_RELATION = `
query getIndividualSummary($individualId: Float!) {
  getIndividualSummary(individualId: $individualId) {
    individualId
    firstName
    middleName
    lastName
    suffix
    dateOfBirth
    genderCode
    relationships {
        companyName
        companyId
        relationshipId
        relationshipBeginDate
        initialTerminationDate
        finalTerminationDate
        terminationDeceasedDate
        terminationEditReason
        terminationExplanation
        terminationReason
        workerClassification
        workerClassificationBeginDate
        lastUpdatedBy
        lastUpdatedDate
        establishedBy
        terminationReason
        terminationEditReason
        terminationExplanation
        terminationDeceasedDate
        terminatedBy
        remoteWorkType
        remoteWorkTypeDescription
        businessPhone
        businessPhoneExtension
        businessEmail
        position
        locations {
            locationId
            locationType
            locationBeginDate
            locationEndDate
            address {
              street1
              street2
              city
              state
              country
              postalCode
            }
        }
        remoteLocation {
          isResidential
          address {
              city
              country
              postalCode
              state
              street1
              street2
          }
          licenseAssociations {
              licenseId
              licenseTypeCode
              licenseTypeDescription
              regulatorCode
              regulatorDescription
              stateCode
              stateDescription
          }
        }
        sponsorships {
          licenseName
          licenseStatus
          regulatorName
          initialAcceptanceDate
          lastUpdatedBy
          lastUpdatedDate
          sponsorshipStatus
          sponsorshipStatusDate
          isActive
        }
    }
  }
}
`;

export const GET_INDIVIDUAL_MU4_RECORDS = `
query($filtersInput: SearchFiltersInput! = {filters: []}, $query:String!, $orderBy: [SearchSorting] = [], $first:Int=25, $skip:Int=0) {
    customFiltersSearch (
      filtersInput: $filtersInput,
      query: $query,
      orderBy: $orderBy,
      first: $first,
      skip: $skip
    ) {
      ...CustomSearchResultFields __typename
    }
}
fragment CustomSearchResultFields on SearchResult {
  total
  cards {
    ...
    WorkItemFields __typename
  }
  filters {
    filterName
    filterField
    filterValues
    customFilters {
        parentFilterValue
        childrenFilters {
            filterName
            filterField
            filterValues
            __typename
        }
        __typename
    }
    total
    __typename
  }
  dynamicFields {
    dataType
    fieldName
    fieldType
    fieldLabel
    __typename
  }
  __typename
}
fragment WorkItemFields on WorkItem {
    ownerType
    ownerId
    ags
    assignees {
        identityProvider
        name
        role
        userId
        __typename
    }
    id
    activeStatus
    category
    typeCode
    actionable
    component
    taskType
    details
    url
    dueDate
    createDate
    lastUpdateDate
    status
    custom
    agsComponentItemId
    sourceId
    groupId
    groupVersionId
    workItemKey
    __typename
}
`;

export const GET_SENSITIVE_DATA_SSN = `
query getSensitiveData($individualId: Float!) {
  getSensitiveData(individualId: $individualId,sensitiveField: ssn,accessedFrom: "Profiles-Individual Summary") {
    ssn
  }
}
`;

export const GET_SENSITIVE_DATA_DOB = `
query getSensitiveData($individualId: Float!) {
  getSensitiveData(individualId: $individualId,sensitiveField: yearOfBirth,accessedFrom: "Profiles-Individual Summary") {
    yearOfBirth
  }
}
`;

export const SEARCH_COMPANY = `
query GetCompaniesByIndividual($pageNumber: Float!) {
    getCompaniesByIndividual(pageParameters: {size: 10, pageNumber: $pageNumber}) {
        individualCompaniesResult {
            companyId
            companyName
            companyMainAddress {
                city
                postalCode
                state
                street1
                street2
            }
        }
        pageInformation {
            currentPageNumber
            currentPageSize
            totalPageCount
            totalRecordsCount
            totalRecordsOnPage
        }
    }
}
`;

export const GRANT_ACCESS_BY_ID = `
query grantCompanyAccess($companyId: Float!) {
  grantCompanyAccess(companyIds:$companyId){
  code
  message
  }
}
`;

export const SEARCH_INDIVIDUAL_BY_ID = `
query searchIndividualById($searchInput: String!, $pageNumber: Float!) {
    getIndividualById(searchInput: $searchInput, pageParameters: {size: 10, pageNumber: $pageNumber}) {
      individualSearchResult {
        companyAccess
        individualId
        legalName
        licenseSponsors
        matchedNames
        monthDayOfBirth
      }
      pageInformation {
        currentPageNumber
        currentPageSize
        totalRecordsCount
        totalPageCount
        totalRecordsOnPage
      }
    }
  }
`;

export const SEARCH_INDIVIDUAL_BY_NAME = `
query searchIndividualByName($searchInput: String!, $pageNumber: Float!) {
    getIndividualByName(searchInput: $searchInput, pageParameters: {size: 10, pageNumber: $pageNumber}) {
      individualSearchResult {
        companyAccess
        individualId
        legalName
        licenseSponsors
        matchedNames
        monthDayOfBirth
      }
      pageInformation {
        currentPageNumber
        currentPageSize
        totalRecordsCount
        totalPageCount
        totalRecordsOnPage
      }
    }
  }
`;

export const SEARCH_INDIVIDUAL_BY_LICENSE = `
query searchIndividualByLicense($searchInput: String!, $pageNumber: Float!) {
    getIndividualByLicenseNumber(searchInput: $searchInput, pageParameters: {size: 10, pageNumber: $pageNumber}) {
      individualSearchResult {
        companyAccess
        individualId
        legalName
        licenseSponsors
        matchedNames
        monthDayOfBirth
      }
      pageInformation {
        currentPageNumber
        currentPageSize
        totalRecordsCount
        totalPageCount
        totalRecordsOnPage
      }
    }
  }
`;

export const SEARCH_INDIVIDUAL_BY_COMPANY = `
query searchIndividualByCompany($searchInput: String, $accessStartDate: String, $accessEndDate: String, $pageNumber: Float!) {
    getIndividualsByCompany(filter: {input: $searchInput, accessGrantedDateRangeStart: $accessStartDate, accessGrantedDateRangeEnd: $accessEndDate}, pageParameters: {size: 10, pageNumber: $pageNumber}) {
      companyAccessIndividualResults {
        individualId
        legalName
        monthDayOfBirth
        activeRelationship
        activeSponsorship
        activeMU2Association
        activeFederalEmployment
        dateAccessGranted
      }
      pageInformation {
        currentPageNumber
        currentPageSize
        totalRecordsCount
        totalPageCount
        totalRecordsOnPage
      }
    }
  }
`;

export const SEARCH_INDIVIDUAL_BY_COMPANY_FOR_PRIOR_RELATIONSHIP = `
query GetEndedCompanyRelationships($searchInput: String, $pageNumber: Float!) {
    getEndedCompanyRelationships(input: {searchInput: $searchInput}, pageParameters: {size: 10, pageNumber: $pageNumber}) {
      endedRelationships {
        fullName
        individualId
        monthDayOfBirth
        initialTerminationDate
        endDate
      }
        pageInformation {
        currentPageNumber
        currentPageSize
        totalRecordsCount
        totalPageCount
        totalRecordsOnPage
      }
    }
  }
`;

export const CHECK_SSN_EXISTS = `
query getSsnExists ($ssn: String!) {
  getSsnExists(ssn: $ssn) {
    ssnExists
    message
  }
}
`;

export const SEARCH_COMPANY_BY_ID = `
query getCompanyById($searchInput: String!, $pageNumber: Float!) {
 getCompanyById(searchInput: $searchInput, pageParameters: {size: 10, pageNumber: $pageNumber}) {
    companySearchResult {
      companyAccess
      nmlsId
      companyName
      matchedNames
      street1
      street2
      city
      state
      country
      postalCode
      locations {
           locationId
           locationType
           address {
              street1
              street2
                city
                state
                country
                postalCode
             }
           }
            licenses {
                licenseId
                licenseTypeCode
          }
    }
    pageInformation {
      currentPageNumber
      currentPageSize
      totalRecordsCount
      totalPageCount
      totalRecordsOnPage
    }
  }
}
`;

export const GET_STATES_REFERENCE_DATA = `
 query getReferenceData() {
  getReferenceData(referenceKey!, activeData): ReferenceDataResponse!
}
`;

export const SEARCH_COMPANY_BY_NAME = `
query getCompanyByName($searchInput: String!,$state:String, $pageNumber: Float!) {
  getCompanyByName(searchInput: $searchInput, state: $state, pageParameters: {size: 10, pageNumber: $pageNumber}) {
    companySearchResult {
      companyAccess
      nmlsId
      companyName
      matchedNames
      street1
      street2
      city
      state
      country
      postalCode
      locations {
           locationId
           locationType
           address {
                street1
                street2
                city
                state
                country
                postalCode
             }
        }
          licenses {
                licenseId
                licenseTypeCode
          }
      }

    pageInformation {
      currentPageNumber
      currentPageSize
      totalRecordsCount
      totalPageCount
      totalRecordsOnPage
    }
  }
}
`;

export const CREATE_PREPOPULATED_FILING = `
query createPrepopulatedFiling ($individualEntityId: Float!) {
  createPrepopulatedFiling(getFilingParams: {subjectId: $individualEntityId}) {
    decafId
  }
}
`;

export const PENDING_COMPANY_ACCESS_LIST = `
query ListCompanyAccessRequests($pageNumber: Float!) {
    listCompanyAccessRequests(pageParameters: {size: 10, pageNumber: $pageNumber}) {
      pendingCompanyAccessRequests {
        individualId
        legalName
        monthDayOfBirth
        workItemId
        dateAccessRequested
        lastReminderDate
      }
      pageInformation {
        totalRecordsCount
        currentPageNumber
        currentPageSize
        totalPageCount
        totalRecordsOnPage
      }
    }
  }
`;

export const SPONSORSHIP_LICENSE_LIST = `
query ListSponsorableLicenses($companyRelationshipId: Float!, $individualId: Float!) {
    listSponsorableLicenses(sponsorableLicenseRequest: {companyRelationshipId: $companyRelationshipId, individualId: $individualId}) {
      sponsorableLicenses {
            licenseId
            licenseStatus
            licenseTypeCode
            licenseTypeDescription
            regulatorCode
            regulatorDescription
            sponsorshipFee
            stateCode
            stateDescription
      }
    }
  }
`;

export const LIST_LICENSES = `
query ListLicenses($subjectId: Float!, $onlyActive: Boolean) {
    listLicenses(subjectId: $subjectId, onlyActive: $onlyActive, pageParameters: {size: 100, pageNumber: 1}) {
      licenses {
        id
        typeCode
        regulatorCode
        typeName
        regulatorDescription
        licenseNumber
        statusCode
        statusDescription
        statusDate
        isActive
        availableActions
        itemsCount
      }
      agencyLicenses {
        id
        typeCode
        regulatorCode
        typeName
        regulatorDescription
        licenseNumber
        statusCode
        statusDescription
        statusDate
        isActive
        availableActions
        itemsCount
      }
      otherLicenses {
        id
        typeCode
        regulatorCode
        typeName
        regulatorDescription
        licenseNumber
        statusCode
        statusDescription
        statusDate
        isActive
        availableActions
        itemsCount
      }
    }
  }
`;

export const LIST_COMPANY_LICENSES = `
query ListCompanyLicenses($companyId: Float!, $pageParameters: PageParameters) {
    listCompanyLicenses(companyId: $companyId, pageParameters: $pageParameters) {
      licenses {
        id
        typeCode
        regulatorCode
        typeName
        regulatorDescription
        licenseNumber
        statusCode
        statusDescription
        statusDate
        licenseEntityId
        isActive
        availableActions
        itemsCount
      }
      pageInformation {
        currentPageNumber
        currentPageSize
        totalPageCount
        totalRecordsCount
        totalRecordsOnPage
      }
    }
  }
`;

export const QUICK_LINKS = `
query GetQuickLinks {
    getQuickLinks {
        flags {
            federalAccessExists
            grantCompanyAccess
            mu2Attestation
            renewalHome
            requestBackground
            requestCreditReport
            scheduleFingerPrints
            testingHome
            updateRecord
            viewCompleteRecordInformation
            viewEducationCompletionRecord
            viewInvoices
            viewFederalMloRegistryInformation
            viewInformationRequests
        }
        links {
            federalMLO
            grantCompanyAccess
            mu2Attestation
            renewalHome
            requestBackground
            requestCreditReport
            scheduleFingerPrints
            testingHome
            updateRecord
            viewCompleteRecordInformation
            viewEducationCompletionRecord
            viewInvoices
            viewInformationRequests
        }
    }
}
`;

export const GET_LICENSES_INFO = `
query getLicensesInfo($input: GetLicensesInput) {
  getLicensesInfo(input: $input) {
    licenseId
    licenseTypeCode
    licenseTypeDescription
    licenseStatusCode
    licenseStatusCodeDescription
    entityId
    entityName
    entityType
    assigneeUsername
    assigneeFirstName
    assigneeLastName
    openIRCount
    irCount
    openSystemTaskCount
    systemTaskCount
  }
}
`;

export const GET_COMPANY_USERS = `
  query GetCompanyUsers {
    getCompanyUsers {
      users {
        id
        firstName
        middleName
        lastName
        suffix
        username
      }
    }
  }
`;

/**
 * Fetches all Information Requests (IRs) associated with a specific license
 * @param licenseId - The unique identifier of the license
 * @returns List of IRs with their details including comments, status, and assignee information
 */
export const GET_IRS_UNDER_LICENSE = `
query getIRsUnderLicense($licenseId: String) {
              getIRsUnderLicense(licenseId: $licenseId) {
                irs {
                  irId
                  activeStatus
                  irName
                  taskId
                  statusDescription
                  irCategoryDescription
                  dueDate
                  statusDate
                  licenseType
                  lastUpdatedByFirstname
                  lastUpdatedByLastname
                }
              }
            }
`;

export const GET_LICENSE_WORK_ITEMS = `
query getLicenseWorkItems($licenseId: String!, $activeStatus: String!, $limit: Int = 10, $offset: Int = 0) {
  getLicenseWorkItems(input: { licenseId: $licenseId, activeStatus: $activeStatus, limit: $limit, offset: $offset }) {
    items {
      itemType
      status
      statusDate
      title
      ir {
        irId
        irName
        irCategoryDescription
        statusDescription
        statusDate
        dueDate
        lastUpdatedByFirstname
        lastUpdatedByLastname
        activeStatus
      }
      systemTask {
        systemTaskId
        taskType
        status
        statusDate
        dueDate
        lastUpdatedByFirstName
        lastUpdatedByLastName
        activeStatus
      }
    }
    pageInfo {
      total
      offset
      limit
      hasNextPage
      hasPreviousPage
    }
  }
}
`;

// TODO: Wire up when backend query is available
export const GET_SYSTEM_TASKS_UNDER_LICENSE = `
query getSystemTasksUnderLicense($licenseId: String!, $subjectId: String!) {
  getSystemTasksUnderLicense(licenseId: $licenseId, subjectId: $subjectId) {
    systemTasks {
      systemTaskId
      taskType
      status
      activeStatus
      statusDate
      dueDate
      lastUpdatedByFirstName
      lastUpdatedByLastName
    }
  }
}
`;
export const GET_SYSTEM_TASK = `
query getSystemTask($systemTaskId: String) {
  getSystemTask(systemTaskId: $systemTaskId) {
    systemTaskId
    isLicenseLevelTask
    licenseInformation {
      entityName
      entityId
      licenseId
      licenseType
      licenseTypeDescription
      licenseStatus
      licenseStatusDescription
      statusDate
      submittedDate
      approvalDate
      regulatorDescription
    }
    systemTaskCode
    description
    createdDate
    dueDate
    assigneeUsername
    subjectEntityName
    subjectEntityId
    status
    statusDate
    resolution
    taskType
  }
}
`;

export const GET_COMPANY_PROFILE = `
query getCompanyProfile($companyId: Float!) {
  getCompanyProfile(companyId: $companyId) {
    identifiers {
      companyId
      companyName
      irsEin
      mailingAddress {
        street1
        street2
        city
        state
        country
        postalCode
      }
      email
      phone
      fax
      hasViewableRegulatoryActions
    }
    contactInformation {
      primaryCompanyContact {
        name
        title
        mailingAddress {
          street1
          street2
          city
          state
          country
          postalCode
        }
        email
        phone
      }
      primaryConsumerComplaintContact {
        name
        title
        mailingAddress {
          street1
          street2
          city
          state
          country
          postalCode
        }
        email
        phone
      }
    }
  }
}
`;

export const GET_INFORMATION_BY_ID = `
query getInformationRequestById($irId: String!) {
              getInformationRequestById(input: {irId: $irId}) {
                irId
                licenseId
                taskId
                irName
                irDetails
                isConfidential
                comments {
                  title
                  description
                  createdDate
                  lastUpdatedDate
                  commentByFirstName
                  commentByLastName
                  commentByMiddleName
                }
                dueDate
                statusDescription
                irCategoryDescription
                createdDate
                createdByFirstname
                createdByLastname
                lastUpdatedByUsername
                lastUpdatedByFirstname
                lastUpdatedByLastname
                lastUpdatedDate
                assigneeUsername
              }
}`;
